module.exports = __webpack_public_path__ + "static/img/4_1_2.5437d5ff.jpg";